import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["aria-label"];
const _hoisted_2 = {
  class: "h5-channel-nav__scroll"
};
const _hoisted_3 = {
  class: "h5-channel-nav__icon",
  "aria-hidden": "true"
};
const _hoisted_4 = {
  class: "h5-channel-nav__label"
};
import { computed } from 'vue';
import NavChannelIcon from '@/components/icons/NavChannelIcon.vue';
import NavAppDownloadEntry from '@/components/nav/NavAppDownloadEntry.vue';
import { useRoute } from 'vue-router';
import { H5_CHANNEL_NAV_ITEMS } from '@/constants/h5ChannelNav.js';
import { useJackpotFeature } from '@/composables/useJackpotFeature.js';
import { trackAnalyticsLog } from '@/utils/analytics-track';
export default {
  __name: 'H5ChannelNav',
  setup(__props) {
    const route = useRoute();
    const {
      enabled: jackpotFeatureEnabled
    } = useJackpotFeature();
    const items = computed(() => H5_CHANNEL_NAV_ITEMS.filter(item => item.feature !== 'jackpot' || jackpotFeatureEnabled.value));
    function isActive(item) {
      return item.match(route.path);
    }
    function onChannelClick(item) {
      const channel = String(item?.key || '').trim();
      if (!channel) return;
      trackAnalyticsLog({
        key: 'channel.switch',
        label: '频道切换',
        value: {
          channel,
          source: 'h5'
        }
      });
    }
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      return _openBlock(), _createElementBlock("nav", {
        class: "h5-channel-nav",
        role: "navigation",
        "aria-label": _ctx.$t('nav.mobileChannelNav')
      }, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, item => {
        return _openBlock(), _createBlock(_component_router_link, {
          key: item.key,
          to: item.to,
          class: _normalizeClass(["h5-channel-nav__item", {
            'is-active': isActive(item)
          }]),
          "aria-current": isActive(item) ? 'page' : undefined,
          onClick: $event => onChannelClick(item)
        }, {
          default: _withCtx(() => [_createElementVNode("span", _hoisted_3, [_createVNode(NavChannelIcon, {
            name: item.icon,
            active: isActive(item)
          }, null, 8, ["name", "active"])]), _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t(item.labelKey)), 1)]),
          _: 2
        }, 1032, ["to", "class", "aria-current", "onClick"]);
      }), 128))]), _createVNode(NavAppDownloadEntry, {
        class: "h5-channel-nav__app"
      })], 8, _hoisted_1);
    };
  }
};